"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseJsonRef = parseJsonRef;
exports.stringifyJsonRef = stringifyJsonRef;
exports.updateJsonRefs = updateJsonRefs;
/**
 * Parse a json reference into its file and path.
 * @param ref Json reference string.
 * @returns Parsed json reference
 */
function parseJsonRef(ref) {
    const [file, path] = ref.split("#");
    return {
        file: file === "" ? undefined : file,
        path: path === undefined ? undefined : decodeURIComponent(path),
    };
}
/**
 * Convert a @see {JsonRef} into its string format.
 * @param ref Json reference
 * @returns jsonref string.
 */
function stringifyJsonRef(ref) {
    var _a;
    const path = ref.path === undefined ? "" : `#${ref.path}`;
    return `${(_a = ref.file) !== null && _a !== void 0 ? _a : ""}${path}`;
}
/**
 * Update the given document $ref in place using the modifier. Calls the modifier for each instance of a $ref.
 * @param document Document with $ref to update.
 * @param modifier Modifier
 */
function updateJsonRefs(document, modifier) {
    for (const value of Object.values(document)) {
        if (value && typeof value === "object") {
            const ref = value.$ref;
            if (ref && typeof ref === "string") {
                value.$ref = modifier(ref);
            }
            updateJsonRefs(value, modifier);
        }
    }
    return document;
}
//# sourceMappingURL=refs.js.map